export const ProductNotes = {
    replacement: "replacement",
    replaced: "replaced",
    added: "added",
    modified: "modified",
    canceled: "canceled"
}